import React from 'react';
export function TricolorStripe({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex h-1.5 w-full ${className}`} data-id="element-280">
      <div className="flex-1 bg-[#008C45]" data-id="element-281" />
      <div className="flex-1 bg-white" data-id="element-282" />
      <div className="flex-1 bg-[#CD212A]" data-id="element-283" />
    </div>;
}